<template>
  <div class="leaderboard-table__heading">
    <div
      v-for="headingItem in headingItems"
      :key="headingItem.text"
      class="leaderboard-table__heading-cell"
    >
      {{ headingItem.text }}
    </div>
  </div>
</template>

<script>
export default {
  name: "LeaderBoardTableHead",
  props: ["headingItems"]
};
</script>

<style scoped>
.leaderboard-table__heading {
  color: #6e8ca0;
  font-weight: 300;
  display: flex;
  justify-content: space-between;
}
.leaderboard-table__heading-cell {
  font-weight: 300;
  text-transform: uppercase;
  font-size: 14px;
}
</style>
